import { FC, createContext, useContext, useMemo, useState, useCallback } from 'react'
import {
  QueryRequestContextProps,
  QueryState,
  WithChildren,
  initialQueryRequest,
} from '../../../../../../_metronic/helpers'

/** Filtros da aba "Minha escala" que não fazem parte do `search` da listagem. */
export type ParamsMinhaEscala = {
  /** Intervalo visível do calendário (`LocalDate`). */
  inicio?: string
  termino?: string
  /** Filtros opcionais do calendário. */
  empresa?: number
  especialidade?: number
}

const QueryRequestContext = createContext<QueryRequestContextProps<unknown>>(initialQueryRequest)

export const QueryRequestProvider: FC<WithChildren> = ({ children }) => {
  const [state, setState] = useState<QueryState<unknown>>({
    ...initialQueryRequest.state,
    fixedSort: [{ field: 'dataInicio', order: 'desc' }],
  })

  const updateState = useCallback(
    (updates: Partial<QueryState<unknown>>) => setState((prev) => ({ ...prev, ...updates })),
    []
  )

  const value = useMemo(() => ({ state, updateState }), [state, updateState])

  return <QueryRequestContext.Provider value={value}>{children}</QueryRequestContext.Provider>
}

export const useQueryRequest = <TParams = ParamsMinhaEscala,>() =>
  useContext(QueryRequestContext) as QueryRequestContextProps<TParams>
